import { useCallback, useContext, useLayoutEffect, useRef } from "react";
import { MasterAdminContext } from "./MasterAdminContext.jsx";

const useMasterAdminFormHeader = ({
  enabled,
  action,
  revision,
  getViewConfig,
  onBack,
}) => {
  const context = useContext(MasterAdminContext);
  const setFormView = context?.setFormView;
  const clearFormView = context?.clearFormView;
  const onBackRef = useRef(onBack);
  const getViewConfigRef = useRef(getViewConfig);

  useLayoutEffect(() => {
    onBackRef.current = onBack;
    getViewConfigRef.current = getViewConfig;
  });

  const clearFormHeader = useCallback(() => {
    clearFormView?.();
  }, [clearFormView]);

  useLayoutEffect(() => {
    if (!enabled || !setFormView || !clearFormView) {
      return;
    }

    if (!action) {
      clearFormView();
      return;
    }

    const config = getViewConfigRef.current(action);
    if (!config) {
      clearFormView();
      return;
    }

    setFormView({
      title: config.title,
      subtitle: config.subtitle,
      backLabel: config.backLabel,
      onBack: () => onBackRef.current?.(),
    });
  }, [enabled, action, revision, setFormView, clearFormView]);

  return clearFormHeader;
};

export default useMasterAdminFormHeader;
